import { SliderProps } from '@chakra-ui/react';
import { useCallback, useEffect, useState } from 'react';
import { Slider } from '~/components/Slider';
import { addSteps } from '~/screens/MyAgency/components/FiltersDrawer/helpers';
import { useAdvancedFiltersStore } from '~/screens/MyAgency/store/useAdvancedFiltersStore';
import {
  CriteriaProps,
  IGFilters,
  Platform,
  TikTokFilters,
  YouTubeFilters,
} from '~/screens/MyAgency/types';

interface Props extends SliderProps {
  title: string;
  value: number;

  metrics: CriteriaProps[];
  filterType: keyof IGFilters | keyof YouTubeFilters | keyof TikTokFilters;
  isDisabled?: boolean;
}

export const MetricsSlider: React.FC<Props> = ({
  title,
  value,
  metrics,
  filterType,
  isDisabled,
  ...props
}) => {
  const marks = addSteps(metrics);

  const [previewValue, setPreviewValue] = useState<CriteriaProps>(metrics[0]);

  const { activePlatform, setFilter } = useAdvancedFiltersStore();

  useEffect(() => {
    // This useEffect is updates the slider preview value when the store updates
    const step = marks.find(
      (m) => m.stepValue === Number(value),
    ) as CriteriaProps;

    if (step) setPreviewValue(step);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const onChange = useCallback(
    (value: number) => {
      setPreviewValue(marks[value]);
    },
    [setPreviewValue, marks],
  );

  const onChangeEnd = useCallback(
    (value: number) => {
      setFilter(
        // @platfom-type-issue making a tag so I can fix these issues without casting from top level
        activePlatform as Platform,
        filterType as any,
        marks[value].stepValue,
      );
    },
    [setFilter, activePlatform, filterType, marks],
  );

  return (
    <Slider
      title={title}
      label={previewValue.label}
      value={previewValue.value}
      marks={marks}
      onChange={onChange}
      step={1}
      isDisabled={isDisabled}
      onChangeEnd={onChangeEnd}
      titleProps={{
        fontWeight: 500,
      }}
      {...props}
    />
  );
};
